import {useEffect, useState} from "react";

import {NetworkProbeResult} from "@/lib/types/network.ts";

import {NetworkProbeDetail} from "./NetworkProbeDetail.tsx";
import {NetworkProbeList} from "./NetworkProbeList.tsx";
import {NetworkProbeModalContext} from "./networkRunTestTypes.ts";

import styles from "./NetworkProbePanels.module.scss";

export const NetworkProbePanels = ({
  probes,
  context,
  initialIndex = 0,
}: {
  probes: NetworkProbeResult[];
  context: NetworkProbeModalContext;
  initialIndex?: number;
}) => {
  const [selected, setSelected] = useState(initialIndex);

  useEffect(() => {
    setSelected(initialIndex);
  }, [probes, initialIndex]);

  const current = probes[selected];

  return (
    <div className={styles.modalBody}>
      <div className={styles.leftPanel}>
        <NetworkProbeList probes={probes} selectedIndex={selected} onSelect={setSelected} />
      </div>
      <div className={styles.detailPanel}>{current && <NetworkProbeDetail probe={current} context={context} />}</div>
    </div>
  );
};
